import React, { useState, useEffect, useCallback } from "react";
import { Modal, Spinner, Alert, Button } from "react-bootstrap";
import apiClient from "../../utils/api/apiClient";
import { APIEndpoints } from "../../utils/api/apiConfig";
import { t } from 'i18next'
import { getErrorMessageFromApiResponse } from "../../utils/api/apiUtils";
import ComplaintCard from "../Complaints/ComplaintCard";
import { makeCall } from '../../utils/api/makeCall'
import { ButtonWithLoadingState } from '../Buttons'

const ComplaintCardModal = ({ complaintId, handleClose }) => {
    const [complaintDetails, setComplaintDetails] = useState({})
    const [selectedPositions, setSelectedPositions] = useState([])
    const [dataIsLoading, setDataIsLoading] = useState(true)
    const [error, setError] = useState('')
    const [/*errorStates*/, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})

    const initData = useCallback(async () => {
        try {
            let resp = await apiClient.getJson(APIEndpoints.returns(complaintId).details)
            setComplaintDetails(resp)
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        } finally {
            setDataIsLoading(false)
        }
    }, [complaintId])


    useEffect(() => {
        initData()
    }, [initData])

    const handleRemoveComplaint = async () => {
        await makeCall(
            'removeComplaint',
            async () => {
                await apiClient.deleteJson(APIEndpoints.returns(complaintId).details)
                handleClose(true)
            },
            setErrorStates,
            setLoadingStates
        )
    }
    const handleOnSelection = (id, selected) => {
        var newValues = [...selectedPositions]
        if (selectedPositions.includes(id)) {
            if (selected) {
                return;
            }
            let index = selectedPositions.indexOf(id)
            newValues.splice(index, 1)
        } else {
            if (!selected) {
                return;
            }
            newValues.push(id)
        }
        setSelectedPositions(newValues)
    }
    const handleRemoveComplaintPositions = async () => {
        await makeCall(
            'removeComplaintPositions',
            async () => {
                await apiClient.postJson(APIEndpoints.returns(complaintId).positions, {removedPositionIds : selectedPositions})
                handleClose(true)
            },
            setErrorStates,
            setLoadingStates
        )
    }
    return (
        <Modal size="lg" centered show={true} onHide={handleClose} scrollable>
            <Modal.Header closeButton className="pb-0">
                <Modal.Title>
                    <div>
                        <p className="m-0 pt-2">Details</p>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {dataIsLoading ? <div className='d-flex justify-content-center p-5'><Spinner animation='border' variant='primary' /></div>
                    : <>
                        <ComplaintCard
                            key={complaintDetails.id}
                            item={complaintDetails}
                            reloadComplaints={() => { }}
                            updateComplaint={() => { }}
                            positionsAreSelectable={true}
                            handleOnSelection={handleOnSelection}
                        />
                    </>
                }
                {error && <Alert variant="danger">{error}</Alert>}
            </Modal.Body >
            <Modal.Footer >
                {(complaintDetails.type === 'retoure') &&
                    (
                        <>
                            <ButtonWithLoadingState
                                variant='danger'
                                onClick={handleRemoveComplaintPositions}
                                buttonText={'Auswahl löschen'}
                                disabled={!selectedPositions.length}
                                isLoading={loadingStates.removeComplaintPositions}
                                />
                            <ButtonWithLoadingState
                                variant='danger'
                                onClick={handleRemoveComplaint}
                                buttonText={'Retoure löschen'}
                                isLoading={loadingStates.removeComplaint}
                                />
                        </>
                    )}
                <Button
                    variant='primary'
                    onClick={handleClose}
                >
                    {t('closeButton')}
                </Button>
                
            </Modal.Footer>
        </Modal >
    )
}

export default ComplaintCardModal
